// @ts-ignore
import {FormConfig, PropertyConfig} from "./FormConfig.ts";
import {Ref} from "@vue/composition-api";

export class TreeConfig extends FormConfig {
    public rootAction: string
    public actionData: any

    constructor(
        public readonly data: Ref<any>,
        public readonly configs: Array<PropertyConfig>,
        public readonly entity: string,
    ) {
        super(data, configs, entity);
    }

    public withRootAction(rootAction: string, actionData: any) {
        this.rootAction = rootAction;
        this.actionData = actionData
        return this;
    }

}
